import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {ItemGridPage} from './item-grid-page';
import {ItemRouteModule} from '../../routes/item/item.route';
import {SharedModule} from '../../shared/shared.module';
import {CategoryGuard} from '../../core/guards/category.guard';
import {ClearCartGuard} from 'src/app/core/guards/clear-cart.guard';
import {ComboModifier} from 'src/app/routes/item/combo-modifier.module';
import {AppItemModule} from '../../components/item/item.module';
import { GridLayoutItemModule } from './../../components/grid-layout-item/grid-layout-item.module';

@NgModule({
    declarations: [ItemGridPage],
    imports: [
    SharedModule,
        ItemRouteModule,
        ComboModifier,
        AppItemModule,
        GridLayoutItemModule,
        RouterModule.forChild([
            {
                path: '',
                canActivate: [CategoryGuard],
                canDeactivate: [ClearCartGuard],
                component: ItemGridPage
            },

        ])
    ]
})
export class ItemGridModule {
}
